import React, { useState, useEffect, useRef } from "react";
import styles from './SearchableComboBox.module.css';

function SearchableComboBox({
    setAttribute,
    optionsData,
    value,
    styleInput,
    mainStyle,
    description,
    setterDescription,
    disabled,
    readOnly,
    className,
    onBlur,
    placeholder
}) {
    const [filteredOptions, setFilteredOptions] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const wrapperRef = useRef(null);

    useEffect(() => {
        if (optionsData && optionsData.props && optionsData.props.children) {
            const children = Array.isArray(optionsData.props.children)
                ? optionsData.props.children
                : [optionsData.props.children];

            const flattened = children.flat();
            setFilteredOptions(flattened);

            const selectedOption = flattened.find(
                (opt) => opt.props.value === value
            );

            if (selectedOption) {
                setterDescription(selectedOption.props.children);
            }
        }
    }, []);

    const handleInputChange = (e) => {
        const inputValue = e.target.value;
        setAttribute(null)
        setterDescription(inputValue);
        setShowDropdown(true);

        if (optionsData && optionsData.props && optionsData.props.children) {
            const children = Array.isArray(optionsData.props.children)
                ? optionsData.props.children
                : [optionsData.props.children];

            const flattened = children.flat();
            const filtered = flattened.filter(option =>
                option.props.children &&
                option.props.children.toLowerCase().includes(inputValue.toLowerCase())
            );
            setFilteredOptions(filtered);
        }
    };

    const handleOptionSelect = (option) => {
        const selectedText = option.props.children;
        setAttribute(option.props.value);
        setterDescription(selectedText);

        const children = Array.isArray(optionsData.props.children)
            ? optionsData.props.children
            : [optionsData.props.children];

        const flattened = children.flat();

        const filtered = flattened.filter(opt =>
            opt.props.children &&
            opt.props.children.toLowerCase().includes(selectedText.toLowerCase())
        );

        setFilteredOptions(filtered);
        setShowDropdown(false);
    };

    const handleClickOutside = (event) => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            setShowDropdown(false);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleInputFocus = () => {
        setShowDropdown(true);

        if ((!filteredOptions || filteredOptions.length === 0) && optionsData?.props?.children) {
            const children = Array.isArray(optionsData.props.children)
                ? optionsData.props.children
                : [optionsData.props.children];

            setFilteredOptions(children.flat());
        }
    };

    return (
        <div ref={wrapperRef} style={{ position: 'relative', ...mainStyle }}>
            <input
                className={className || styles.combobox}
                type="text"
                value={value ? description : null}
                onChange={handleInputChange}
                onFocus={handleInputFocus}
                disabled={disabled}
                readOnly={readOnly}
                style={{ ...styleInput, cursor: 'text' }}
                onBlur={onBlur}
                placeholder={placeholder}
            />
            {showDropdown && filteredOptions.length > 0 && (
                <ul style={{
                    position: 'absolute',
                    zIndex: 10,
                    backgroundColor: 'white',
                    border: '1px solid #ccc',
                    width: '150px',
                    maxHeight: '120px',
                    borderRadius: '4px',
                    overflowY: 'auto',
                    margin: 0,
                    padding: 0,
                    listStyle: 'none'
                }}>
                    {filteredOptions.map((option, index) => (
                        <li
                            key={index}
                            style={{ padding: '8px', cursor: 'pointer' }}
                            onMouseDown={() => handleOptionSelect(option)}
                        >
                            {option.props.children}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}

export default SearchableComboBox;
